<template>
  <div>
    <v-layout row wrap justify-center align-center>
      <v-flex xs11 md11 lg11>
        <v-card class="rounded-lg mt-2" outlined>
          <v-card-text class="pa-2">
            <v-layout row wrap justify-center ma-0 pa-2>
              <v-container>
                <b>{{ $t("consentlist.Specifysearchconditions") }}</b>
                <br />
                <v-form ref="form">
                  <v-layout row wrap justify-center align-baseline>
                    <v-flex xs9 lg3 pa-2>
                      <v-menu
                        ref="menu1"
                        v-model="menu1"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            hide-details
                            color="#077893"
                            clearable
                            outlined
                            dense
                            v-model="FromDate"
                            :label="$t('consentlist.submission')"
                            persistent-hint
                            prepend-icon="mdi-calendar-outline"
                            v-bind="attrs"
                            @blur="date = parseDate(FromDate)"
                            v-on="on"
                            @click:clear="ToDate = ''"
                          >
                          </v-text-field>
                        </template>
                        <v-date-picker
                          locale="TH"
                          color="#077893"
                          v-model="date"
                          no-title
                          @input="menu1 = false"
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs9 lg3 pa-2>
                      <v-menu
                        ref="menu2"
                        v-model="menu2"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            hide-details
                            color="#077893"
                            clearable
                            outlined
                            dense
                            v-model="ToDate"
                            :label="$t('consentlist.to')"
                            persistent-hint
                            prepend-icon="mdi-calendar-outline"
                            v-bind="attrs"
                            @blur="date2 = parseDate2(ToDate)"
                            v-on="on"
                          >
                          </v-text-field>
                        </template>
                        <v-date-picker
                          locale="TH"
                          color="#077893"
                          v-model="date2"
                          no-title
                          @input="menu2 = false"
                          :min="FromDate"
                          :max="TodateMax"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs9 lg3 pa-2>
                      <v-select
                        color="#077893"
                        hide-details
                        v-model="SourceStatus"
                        :items="$t('email.status')"
                        :label="$t('petition.text14')"
                        clearable
                        dense
                        outlined
                        prepend-icon="mdi-format-list-bulleted-type"
                      >
                      </v-select>
                    </v-flex>
                    <v-flex xs9 lg3 pa-2>
                      <v-select
                        color="#077893"
                        prepend-icon="mdi-card-text-outline"
                        :items="ItemPolicy"
                        item-value="PolicyId"
                        item-text="Title"
                        v-model="policyID"
                        :label="$t('dashboard.policy')"
                        clearable
                        dense
                        outlined
                      ></v-select>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center align-baseline mt-n6>
                    <v-flex xs9 lg3 pa-2>
                      <v-select
                        color="#077893"
                        prepend-icon="mdi-card-text-outline"
                        :items="ItemConsentGeneral"
                        item-value="ConsentId"
                        item-text="HeaderConsent"
                        v-model="consentID"
                        :label="$t('Toolbar.consent')"
                        clearable
                        dense
                        outlined
                        hide-details
                      ></v-select>
                    </v-flex>
                    <v-flex xs9 lg3 pa-2>
                      <v-select
                        hide-details
                        color="#077893"
                        prepend-icon="mdi-card-text-outline"
                        :items="ItemConsentGroup"
                        item-value="GroupId"
                        item-text="GroupName"
                        v-model="groupID"
                        :label="$t('consentlist.groupC')"
                        clearable
                        dense
                        outlined
                      ></v-select>
                    </v-flex>
                    <v-flex xs9 lg3 pa-2>
                      <v-text-field
                        color="#077893"
                        clearable
                        hide-details
                        prepend-icon="mdi-account-outline"
                        :label="$t('email.text8')"
                        dense
                        outlined
                        v-model="name"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs9 lg3 pa-2>
                      <v-text-field
                        color="#077893"
                        clearable
                        prepend-icon="mdi-account-cog-outline"
                        label="One Account ID"
                        dense
                        outlined
                        v-model="accountID"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-form>

                <v-layout row wrap justify-end lg-align-end>
                  <v-flex xs12 lg2>
                    <v-btn
                      block
                      dark
                      color="#077893"
                      @click="Start_Search"
                      :loading="LoadingSearch"
                    >
                      <v-icon left> mdi-magnify </v-icon>
                      {{ $t("consentlist.search") }}
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row wrap justify-center ma-0 pa-2>
              <v-flex xs9 lg3 pa-4>
                <v-card outlined class="cyan lighten-5 rounded-lg">
                  <v-card-text class="pa-2 text-center black--text">
                    <div v-if="$t('default') === 'th'">
                      <p style="font-size: 18px; color: #00695c">ทั้งหมด</p>
                    </div>
                    <div v-else>
                      <p style="font-size: 18px; color: #00695c">All</p>
                    </div>
                    <v-chip color="#00695C" dark
                      >{{ all }} {{ $t("consentlist.list") }}</v-chip
                    >
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs9 lg3 pa-4>
                <v-card outlined class="teal lighten-5 rounded-lg">
                  <v-card-text class="pa-2 text-center black--text">
                    <p style="font-size: 18px; color: #077893">
                      {{ $t("onechat.status2") }}
                    </p>
                    <v-chip color="#077893" dark
                      >{{ ok }} {{ $t("consentlist.list") }}</v-chip
                    >
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs9 lg3 pa-4>
                <v-card outlined class="indigo lighten-5 rounded-lg">
                  <v-card-text class="pa-2 text-center black--text">
                    <p style="font-size: 18px; color: #364780">
                      {{ $t("onechat.status5") }}
                    </p>
                    <v-chip color="#364780" dark
                      >{{ read }} {{ $t("consentlist.list") }}</v-chip
                    >
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs9 lg3 pa-4>
                <v-card outlined class="orange lighten-5 rounded-lg">
                  <v-card-text class="pa-2 text-center black--text">
                    <p style="font-size: 18px; color: #f39c12">
                      {{ $t("onechat.status4") }}
                    </p>
                    <v-chip color="#F39C12" dark
                      >{{ wait }} {{ $t("consentlist.list") }}</v-chip
                    >
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-data-table
              :headers="headers"
              :items="ItemConsent"
              hide-default-footer
              :page.sync="Page"
              @page-count="PageCount = $event"
              :items-per-page="ItemPerPage"
            >
              <template v-slot:[`item.ChatId`]="{ item }">
                <div class="text-left">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        color="#077893"
                        style="cursor: pointer"
                        small
                        @click="Fn_CopyDetail(item.ChatId)"
                        v-on="on"
                        >mdi-file-multiple-outline</v-icon
                      >
                    </template>
                    <span>{{ $t("consentlist.copy") }}</span>
                  </v-tooltip>
                  {{ item.ChatId }}
                </div>
              </template>
              <template v-slot:[`item.Email`]="{ item }">
                {{ item.Email }}
              </template>
              <template v-slot:[`item.NameTh`]="{ item }">
                <div v-if="$t('default') === 'th'">{{ item.NameTh }}</div>
                <div v-else>{{ item.NameEng }}</div>
              </template>
              <template v-slot:[`item.PolicyHeader`]="{ item }">
                {{ item.PolicyHeader }}
              </template>
              <template v-slot:[`item.SendAt`]="{ item }">
                <div v-if="$t('default') === 'th'">
                  {{ item.SendAt }}
                </div>
                <div v-else>
                  {{ item.SendAtEng }}
                </div>
              </template>
              <template v-slot:[`item.UpdatdeAt`]="{ item }">
                <div v-if="$t('default') === 'th'">
                  {{ item.UpdatdeAt }}
                </div>
                <div v-else>
                  {{ item.UpdatdeAtEng }}
                </div>
              </template>
              <template v-slot:[`item.Type`]="{ item }">
                <div v-if="$t('default') === 'th'">
                  <div v-if="item.Type == 'General'">แบบทั่วไป</div>
                  <div v-else>แบบกลุ่ม</div>
                </div>
                <div v-else>
                  {{ item.Type }}
                </div>
              </template>
              <template v-slot:[`item.SendStatus`]="{ item }">
                <v-chip color="green" dark v-if="item.SendStatus === 'OK'">{{
                  $t("onechat.status4")
                }}</v-chip>
                <v-chip
                  color="error"
                  dark
                  v-else-if="item.SendStatus === 'ER'"
                  >{{ $t("onechat.status3") }}</v-chip
                >
                <v-chip
                  color="warning"
                  dark
                  v-else-if="item.SendStatus === 'WAIT'"
                  >{{ $t("onechat.status7") }}</v-chip
                >
                <v-chip
                  color="indigo"
                  dark
                  v-else-if="item.SendStatus === 'Read'"
                  >{{ $t("onechat.status5") }}</v-chip
                >
              </template>
              <template v-slot:[`item.Resend`]="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-on="on"
                      v-bind="attrs"
                      color="info"
                      :disabled="item.SendStatus === 'OK'"
                      small
                      fab
                      @click="Fn_SendOnechat(item)"
                    >
                      <v-icon>mdi-send-circle-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("onechat.send2") }} Onechat</span>
                </v-tooltip>
              </template>
            </v-data-table>
            <v-pagination
              :total-visible="7"
              class="pt-2 pb-2"
              circle
              color="#077893"
              v-model="Page"
              :length="PageCount"
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
            >
            </v-pagination>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <div v-if="loadingDownloadData">
      <OverlaySearch />
    </div>
  </div>
</template>

<script>
import OverlaySearch from "@/components/layouts/LoadingPage.vue";
import authorization from "@/functions/authorization.js";
import { format } from "date-fns";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

export default {
  components: { OverlaySearch },
  data: (vm) => ({
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    date2: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    FromDate: vm.formatDate(
      new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10)
    ),
    ToDate: vm.formatDate(
      new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10)
    ),
    menu1: false,
    menu2: false,
    dark: false,
    Page: 1,
    PageCount: 0,
    ItemPerPage: 10,
    TodateMax: "",
    loadingDownloadData: false,
    LoadingSearch: false,
    status: [
      { text: "ทั้งหมด", value: "" },
      { text: "เปิดอ่านแล้ว", value: "Read" },
      { text: "ส่งสำเร็จ", value: "OK" },
      { text: "รอการตอบกลับ", value: "WAIT" },
    ],
    SourceStatus: "",
    Search: false,
    ItemConsent: [],
    all: "",
    ok: "",
    read: "",
    wait: "",
    policyID: "",
    consentID: "",
    groupID: "",
    // mail: "",
    name: "",
    accountID: "",
    ItemPolicy: [],
    ItemConsentGeneral: [],
    ItemConsentGroup: [],
  }),
  computed: {
    ...mapGetters(["Business"]),
    ...mapGetters(["RoleAccount"]),
    _RoleAccount: {
      get() {
        return this.RoleAccount || "-";
      },
    },
    headers() {
      return [
        {
          text: this.$i18n.t("onechat.oneid"),
          align: "center",
          value: "ChatId",
          sortable: false,
          width: "20%",
        },
        {
          text: this.$i18n.t("onechat.name"),
          value: "NameTh",
          align: "center",
          sortable: false,
          width: "20%",
        },
        {
          text: this.$i18n.t("consentlist.groupSend"),
          value: "GroupSend",
          align: "center",
          sortable: false,
          width: "15%",
        },
        {
          text: this.$i18n.t("consentlist.type"),
          value: "Type",
          align: "center",
          sortable: false,
          width: "10%",
        },
        {
          text: this.$i18n.t("consentlist.date"),
          value: "SendAt",
          align: "center",
          sortable: false,
          width: "20%",
        },
        {
          text: this.$i18n.t("onechat.date"),
          value: "UpdatdeAt",
          align: "center",
          sortable: false,
          width: "20%",
        },
        {
          text: this.$i18n.t("onechat.status"),
          value: "SendStatus",
          align: "center",
          sortable: false,
          width: "10%",
        },
        {
          text: "Resend",
          value: "Resend",
          align: "center",
          sortable: false,
        },
      ];
    },
    _FromDate: {
      get() {
        if (this.FromDate === "" || this.FromDate === null) {
          return "";
        } else {
          return format(new Date(this.FromDate), "yyyyMMdd");
        }
      },
    },
    _ToDate: {
      get() {
        if (this.ToDate === "" || this.ToDate === null) {
          return "";
        } else {
          return format(new Date(this.ToDate), "yyyyMMdd");
        }
      },
    },
    _policyID: {
      get() {
        if (this.policyID === "" || this.policyID === null) {
          return "";
        } else {
          return this.policyID;
        }
      },
    },
    _consentID: {
      get() {
        if (this.consentID === "" || this.consentID === null) {
          return "";
        } else {
          return this.consentID;
        }
      },
    },
    _groupID: {
      get() {
        if (this.groupID === "" || this.groupID === null) {
          return "";
        } else {
          return this.groupID;
        }
      },
    },
    _SourceStatus: {
      get() {
        if (this.SourceStatus === "" || this.SourceStatus === null) {
          return "";
        } else {
          return this.SourceStatus;
        }
      },
    },
  },
  mounted() {
    this.Fn_Search();
    this.Fn_GetPolicy();
    this.Fn_GetConsentGeneral();
    this.Fn_GetConsentGroup();
  },
  methods: {
    async Fn_CopyDetail(val) {
      await navigator.clipboard.writeText(val);
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    formatDate2(date2) {
      if (!date2) return null;

      const [year, month, day] = date2.split("-");
      return `${month}/${day}/${year}`;
    },
    parseDate2(date2) {
      if (!date2) return null;

      const [month, day, year] = date2.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    async Start_Search() {
      this.Search = true;
      this.Fn_Search();
    },
    async Fn_Search() {
      // if (this._FromDate === "" && this._ToDate === "" && this._consentID === "" && this._policyID === "" && this._groupID === "" && this._SourceStatus === "" && this.name === "" && this.accountID === "") {
      //   this.Search = false;
      // } else {
      //   this.Search = true;
      // }
      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
        AccessToken: this.$cookies.get("OneAccessToken"),
        Search: this.Search,
        DateFrom: this._FromDate,
        DateTo: this._ToDate,
        ConsentId: this._consentID,
        PolicyId: this._policyID,
        GroupId: this._groupID,
        SendStatus: this._SourceStatus,
        Name: this.name,
        AccountId: this.accountID,
        // Email: this.mail,
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "onechat/GetLogOneChat",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.ItemConsent = response.data.Message.Consent;
            this.ItemConsentCount = response.data.Message.Count;
            this.all = response.data.Message.Count[0].CountAll;
            this.ok = response.data.Message.Count[0].CountOk;
            this.read = response.data.Message.Count[0].CountRead;
            this.wait = response.data.Message.Count[0].CountWait;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            // Toast.fire({
            //   icon: "error",
            //   title: error.message || error,
            // });
            this.all = 0;
            this.ok = 0;
            this.read = 0;
            this.wait = 0;
          }
        });
    },
    async Fn_SendOnechat(val) {
      this.LoadingSendOnechat = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccessToken: this.$cookies.get("OneAccessToken"),
        ChatId: val.ChatId,
        Type: val.Type,
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "onechat/ReSendChat",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.LoadingSendOnechat = false;

          if (response.data.Status === "OK") {
            Toast.fire({
              icon: "success",
              title: this.$i18n.t("alert.one"),
            });
            this.Fn_Search();
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.LoadingSendOnechat = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetPolicy() {
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "policy/GetApiAllDetailPolicy",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.ItemPolicy = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetConsentGeneral() {
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "consent/GetApiAllDetailConsent",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.ItemConsentGeneral = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetConsentGroup() {
      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "group-consent/GetApiAllGroupConsent",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.ItemConsentGroup = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
  },
  watch: {
    date(val) {
      this.FromDate = this.formatDate2(this.date);
      var date = new Date(this.FromDate);
      date.setDate(date.getDate() + 90);
      this.TodateMax = date.toISOString().substring(0, 10);
    },
    date2(val) {
      this.ToDate = this.formatDate2(this.date2);
    },
    $route(to) {
      document.title = `APPLICATION_NAME - ${to.meta.title}`;
      const link = document.querySelector("[rel='icon']");
      link.setAttribute("href", to.meta.icon);
    },
  },
};
</script>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}
</style>
